/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../graphql.generated'

const defaultOptions = {} as const
export type GetMedicalReportQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetMedicalReportQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    medicalReport?: { __typename?: 'MedicalReport'; url: string; warning?: string | null } | null
  }
}

export const GetMedicalReportDocument = gql`
  query getMedicalReport($uid: ID!) {
    patient(uid: $uid) {
      medicalReport {
        url
        warning
      }
    }
  }
`

/**
 * __useGetMedicalReportQuery__
 *
 * To run a query within a React component, call `useGetMedicalReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicalReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMedicalReportQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetMedicalReportQuery(
  baseOptions: Apollo.QueryHookOptions<GetMedicalReportQuery, GetMedicalReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMedicalReportQuery, GetMedicalReportQueryVariables>(GetMedicalReportDocument, options)
}
export function useGetMedicalReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMedicalReportQuery, GetMedicalReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMedicalReportQuery, GetMedicalReportQueryVariables>(GetMedicalReportDocument, options)
}
export type GetMedicalReportQueryHookResult = ReturnType<typeof useGetMedicalReportQuery>
export type GetMedicalReportLazyQueryHookResult = ReturnType<typeof useGetMedicalReportLazyQuery>
export type GetMedicalReportQueryResult = Apollo.QueryResult<GetMedicalReportQuery, GetMedicalReportQueryVariables>
